
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { environment } from './../../../environments/environment';
import { catchError,retry } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class PointsService {

    constructor(private http: HttpClient) { }

    getPoints(cl: any) {
        return;
    }

    async getPointsList(idCliente: number) {
        return;
    }

    createPoints(idCliente: any, lat: any, lon: any, name: string, description: string, option: string ) {
        return;
    }

    errorHandler = (error: HttpErrorResponse) => {
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
        } else {
            errorMsg = `Código de error: ${error.status}, Mensaje: ${error.message}`
        }
        console.error(errorMsg);
        return throwError(errorMsg)
    }
}
